export const pcrightfixedpanel = () => {};
